import { IconButton, Tooltip, Grid } from '@mui/material'
import React, { useRef, useState } from 'react'
import { QRCode as QRCodeLogo } from 'react-qrcode-logo'
import DownloadForOfflineRoundedIcon from '@mui/icons-material/DownloadForOfflineRounded'

interface QRCodeProps {
  value: string
  logoImage?: string
  size?: number
  logoSize?: number
  qrStyle?: 'dots' | 'squares'
  eyeRadius?: number
  filename?: string
}

const QRCode: React.FC<QRCodeProps> = ({
  value,
  logoImage = '',
  size = 200,
  logoSize = 40,
  qrStyle = 'dots',
  eyeRadius = 10,
  filename = 'QRCode',
}) => {
  const qrCodeRef = useRef<HTMLDivElement>(null)
  const [downloadTooltip, setDownloadTooltip] = useState<string>('Click to download QR Code')

  const handleDownloadQR = () => {
    const canvas = qrCodeRef.current?.querySelector('canvas') as HTMLCanvasElement
    if (canvas) {
      const highResCanvas = document.createElement('canvas')
      const scale = 4
      highResCanvas.width = canvas.width * scale
      highResCanvas.height = canvas.height * scale
      const ctx = highResCanvas.getContext('2d')

      if (ctx) {
        ctx.scale(scale, scale)
        ctx.drawImage(canvas, 0, 0)

        const pngUrl = highResCanvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
        const downloadLink = document.createElement('a')
        downloadLink.href = pngUrl
        downloadLink.download = `${filename}.png`
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
        setDownloadTooltip('QR Downloaded')
        setTimeout(() => setDownloadTooltip('Click to download QR Code'), 2000)
      }
    }
  }

  return (
    <Grid container direction='column' justifyContent='center' alignItems='center' spacing={1}>
      <Grid>
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <div>
            <QRCodeLogo
              value={value}
              size={size}
              logoImage={logoImage}
              logoHeight={logoSize}
              logoWidth={logoSize}
              logoOpacity={1}
              enableCORS={true}
              qrStyle={qrStyle}
              eyeRadius={eyeRadius}
              ecLevel='H'
              id={'qr-code'}
            />
          </div>

          <div ref={qrCodeRef} hidden>
            <QRCodeLogo
              value={value}
              size={size * 5}
              logoImage={logoImage}
              logoHeight={logoSize * 5}
              logoWidth={logoSize * 5}
              logoOpacity={1}
              enableCORS={true}
              qrStyle={qrStyle}
              eyeRadius={eyeRadius}
              ecLevel='H'
              id={'qr-code'}
            />
          </div>

          <Tooltip title={downloadTooltip} arrow>
            <IconButton
              onClick={handleDownloadQR}
              aria-label='download QR code'
              style={{
                position: 'absolute',
                bottom: 10,
                right: 10,
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
              }}
            >
              <DownloadForOfflineRoundedIcon />
            </IconButton>
          </Tooltip>
        </div>
      </Grid>
    </Grid>
  )
}

export default QRCode
